export { ColumnFieldType } from '../../../interfaces/list/ColumnFieldType';

/**
 * This enum represents a the width of a given listview column.
 */
export enum ColumnWidth {
    icon = 16,
    iconMin = 16,
    bigIcon = 48,
    bigIconMin = 48,
    regularMin = 90,
    regular = 130,
    nameMin = 220,
    nameODC = 440,
    nameODB = 280,
    originalLocation = 300,
    custom = 900,
    sharedWith = 150,
    note = 250,
    /** Date Modified in the ml locale is a very long string */
    dateModifiedMl = 150,
    dotDotDot = 32,
    ratingsMin = 110
}

export const enum MappedColumnType {
    none,
    icon,
    name,
    title,
    calloutInvoker,
    shareHeroCommand,
    modified,
    url
}

/**
 * Policy tip type. This is actually a bit flag value.
 */
export const enum PolicyTipType {
    none = 0,
    notify = 1,
    block = 2,
    notifyAndBlock = 3,
    blockSharing = 4
}

/**
 * Represents status to determine whether filters pane will show the field.
 * This should be in sync with ShowInFiltersPaneStatus enum in //depot/sporel/sts/stsom/Core/spfield.cs
 */
export enum ShowInFiltersPaneStatus {
    Auto,
    Pinned,
    Removed
}

/** Types of errors that can be returned by RenderListDataAsStream (used by getItem) */
export const enum ErrorType {
    fileNotFound = -2147024894,
    invalidView = -2147024809,
    listNotFound = -1,
    docAlreadyExists = -2130575257,
    queryThrottled = -2147024860,
    newExperieceRenderingNotSupported = -2, //fake error code, not from server
    onePageNavigationViewMismatch = -3, //fake error code, not from server
    onePageNavigationError = -4 //fake error code, not from server
}
